import * as types from "../actions/actionsTypes";
import initialState from "./initialState";

export default function quizCategoryDataReducer(state = initialState.quizcategoryData, action) {
  switch (action.type) {
    case types.LOADED_QUIZ_CATEGORY_DATA_SUCCESS:
      return action.quizcategoryData;
    default:
      return state;
  }
} 
